import * as Sentry from "@sentry/react";

import { api } from "@/api.ts";

Sentry.init({
  dsn: `https://${__SENTRY_KEY__}@admin.karta.sweco.se/bugsink/1`,
  integrations: [
    Sentry.zodErrorsIntegration(),
    Sentry.httpClientIntegration({
      failedRequestStatusCodes: [400, 404, 422, [500, 599]],
    }),
    Sentry.graphqlClientIntegration({
      endpoints: [/\/graphql$/],
    }),
    Sentry.supabaseIntegration({ supabaseClient: api }),
  ],
  release: __APP_VERSION__,
  tracesSampleRate: 0,
  dataCollection: {
    userInfo: true,
    urlQueryParams: true,
  },
});
